import React, { lazy, Suspense } from 'react';
import Loader from './Loading'
import { general, descriptions, classifications, getDescriptions } from './Categories/BasicInformation/tabsConfig'
import { other } from './Categories/OtherAmenity/tabsConfig'
import Extra from './Categories/OtherAmenity/Extra/Extra'
import GeneralRoomAmenity from './Categories/OtherAmenity/General/General'
import Hotel from './Categories/OtherAmenity/Hotel/Hotel'
import ActionButtonsComponent from './Globals/ActionButtonsComponent'
import BasicInfoClosures from './Categories/BasicInformation/Closures'


const Tabs = lazy(() => import('./Globals/ContentTabs'))
const TabsTableView = lazy(() => import('./Globals/ContentTabsTableView'))
const GeneralInfo = lazy(() => import('../components/Categories/BasicInformation/GeneralInfo/index'))
const Capacities = lazy(() => import('../components/Categories/BasicInformation/Capacities/index'));
const Descriptions = lazy(() => import('../components/Categories/BasicInformation/Descriptions/index'))
const Classifications = lazy( () => import('../components/Categories/BasicInformation/Classifications/index'))
const Contacts = lazy(() => import('../components/Categories/BasicInformation/Contacts/index'))

interface detailTypes {
  type: string,
  isOnEdit: boolean,
  isEditable: void | any,
  cancelEditable: void | any,
  saveEdit: void | any,
  deleteData : void | any,
}

const DetailPageHandler = (props: detailTypes) => {
  
  const [editRow, setEditRow] = React.useState(false)

  React.useEffect(() => {
    if (!props.isOnEdit) {
      setEditRow(false)
    }
  }, [props.isOnEdit])
  
  const Loading = () => {
    return (
      <Loader type="medium" />
    )
  }

  const editItemTable = (e: boolean) => {
    props.isEditable(e)
    setEditRow(e)
  }

  const whichComponentToShow = () => {
    switch (props.type) {
      case 'General':
        return (<GeneralInfo isEditable={props.isEditable} cancelEditable={props.cancelEditable} />)
      case 'Descriptions':
        return ( <Descriptions isEditable={props.isEditable} cancelEditable={props.cancelEditable} /> )
      case 'Contacts':
        return ( <Contacts isEditable={props.isEditable} cancelEditable={props.cancelEditable} /> )
      case 'Capacities':
        return ( <Capacities isEditable={props.isEditable} cancelEditable={props.cancelEditable} /> )
      case 'Classifications':
        return (<Classifications isEditable={props.isEditable} cancelEditable={props.cancelEditable} />)
      case 'Closures':
        return (
          <>
            <BasicInfoClosures />
            <ActionButtonsComponent isOnEdit={ props.isOnEdit } />
          </>
        ) 
      case 'Other Amenity Info':
        return (
          <>
          <TabsTableView
            config={ other }
            isOnEdit={ props.isOnEdit }
            isEditable={ props.isEditable }
            cancelEditable={ props.cancelEditable }
            saveEdit={ props.saveEdit }
          />
          <ActionButtonsComponent isOnEdit={ props.isOnEdit } />
          </>
        ) 
      case 'Extra Accessible Feature & Security':
        return (
          <>
            <Extra />
            <ActionButtonsComponent isOnEdit={ props.isOnEdit } />
          </>
        ) 
      case 'Hotel Closure':
        return (
          <>
            <Hotel />
            <ActionButtonsComponent isOnEdit={ props.isOnEdit } />
          </>
        ) 
      case 'General Room Amenity':
        return (
          <>
            <GeneralRoomAmenity />
            <ActionButtonsComponent isOnEdit={ props.isOnEdit } />
          </>
        ) 
      default:
        return (
          <div> Content </div>
        )
    }
  }

  return (
    <Suspense fallback={Loading()}>
      <div className="col-12">
        { whichComponentToShow() }
      </div>
    </Suspense>
  )
}


export default DetailPageHandler
